<template>
  <el-drawer
  title="Filtres"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <el-form>
      <el-form-item>
        <el-button @click="resetFilters()" size="mini">Remettre les filtres d'origine</el-button>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="associatedContacts">Contacts associés</el-checkbox>
        <el-checkbox v-model="nonAssociatedContacts">Contacts non associés</el-checkbox>
      </el-form-item>
      <h4>Contacts associés à</h4>
      <el-form-item>
        <el-checkbox-group v-model="checkedCustomerTypes" >
          <el-checkbox v-for="t in $store.getters.customerTypes" :disabled="nonAssociatedContacts && !associatedContacts" :label="t.id" :key="t.id" style="margin-left:0px;">{{t.code}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <h5>Classe client</h5>
      <el-form-item>
        <el-checkbox-group  v-model="checkedCustomerClasses" >
          <el-checkbox v-for="cclass in $store.getters.customerClasses" :label="cclass.id" :key="cclass.id" style="margin-left:0px;">{{cclass.code}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <h4>Étiquettes</h4>
      <el-form-item>
         <el-checkbox-group  v-model="checkedTags" >
           <el-checkbox v-for="tag in $store.getters.contactListTags" :label="tag.id" :key="tag.id" style="margin-left:0px;">{{tag.code}}</el-checkbox>
         </el-checkbox-group>
       </el-form-item>
   </el-form>
  </div>
</el-drawer>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'contact-filter',
	props: {
    visible : {type : Boolean},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      value1 : null,
    };
  },components: {

  },
  watch : {

  },
	methods: {
    open(){
      this.$store.dispatch('CONTACT_FETCH_TAGS')
    },
    handleClose(){
      this.$emit('close');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    resetFilters(){
      this.$store.dispatch('CONTACT_RESET_FILTERS');
    }
    // ...mapActions('statuses',['fetchInvoiceStatuses']),
    // ...mapActions('invoices', ['setStatusFilters','resetFilters','setDateFilters'])
	},
	computed: {
		checkedCustomerTypes :{
			set(val){this.$store.dispatch('CONTACT_CHANGE_CUSTOMER_TYPE_FILTER', val)},
			get(){return this.$store.getters.checkedContactCustomerTypes}
		},
		associatedContacts : {
			set(val){this.$store.dispatch('CONTACT_CHANGE_CONTACT_ASSOCIATED_FILTER', val)},
			get(){return this.$store.getters.checkedAssociatedContact}
		},
    nonAssociatedContacts : {
			set(val){this.$store.dispatch('CONTACT_CHANGE_CONTACT_NON_ASSOCIATED_FILTER', val)},
			get(){return this.$store.getters.checkedNonAssociatedContact}
		},
		checkedCustomerClasses :{
			set(val){this.$store.dispatch('CONTACT_CHANGE_CUSTOMER_CLASS_FILTER', val)},
			get(){return this.$store.getters.checkedContactCustomerClasses}
		},
		checkedTags : {
			set(val){this.$store.dispatch('CONTACT_CHANGE_CONTACT_TAGS_FILTER', val)},
			get(){return this.$store.getters.checkedContactTags}
		},
    statusFilter : {
      get(){return this.filters.status;},
      set(statusFilters){this.setStatusFilters(statusFilters)}
    },
    dateFilter : {
      get(){return this.filters.date},
      set(dateFilter){this.setDateFilters(dateFilter)}
    },
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "40%";
      }else{
        return "100%"
      }
    },
    // ...mapState('statuses',['invoiceStatuses']),
    // ...mapState('invoices',['filters'])
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

// .el-row {
//     margin-bottom: 20px;
//     &:last-child {
//       margin-bottom: 0;
//     }
//   }

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
